@import 'styles/mixins.scss';

.processingContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;

  &.whiteBackround {
    background: var(--light-100);
  }

  &.transparentBackground {
    background: transparent;
  }
}

.loadingTextContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 622px;
  align-items: center;
  text-align: center;
  gap: 36px;

  @include for-phone-only {
    width: 100%;
  }
}

.headingsContainer {
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 16px;

  @include for-phone-only {
    gap: 20px;
    width: 100%;
  }
}

.progressBar {
  border-radius: 168.685px;
  border: 1px solid var(--dark-15);
  width: 100%;
  height: 12px;
  padding: 2px;

  .progress {
    background: var(--dark-15);
    border-radius: 168.685px;
    height: 100%;
  }

  .progressPercentage {
    width: 100px;
  }
}

.processingContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 36px;

  .textAndControls {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.progressHeading {
  display: flex;
  padding: 15px;
  justify-content: center;
  align-items: flex-start;
  border-radius: 100px;
  border: 1px solid rgba(0, 153, 247, 0.16);
  background: var(--light-100);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.06);
  opacity: 0.3;
  width: 100%;
  padding: 0;
  border: none;
  box-shadow: none;
  background: transparent;
  justify-content: flex-start;

  &.running {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #fff 100%);
    opacity: 1;

    &.tintBlue {
      span {
        background: linear-gradient(
          92deg,
          rgba(0, 80, 180, 0.6) 4.97%,
          rgba(65, 150, 253, 0.6) 23.86%,
          rgba(0, 80, 180, 0.6) 42.76%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-size: 500% auto;
        animation: textShine 2s ease-in-out infinite alternate;
      }
    }

    span {
      background: linear-gradient(
        92deg,
        rgba(0, 0, 0, 0.6) 4.97%,
        rgba(163, 163, 163, 0.6) 23.86%,
        rgba(0, 0, 0, 0.6) 42.76%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-size: 500% auto;
      animation: textShine 2s ease-in-out infinite alternate;
    }
  }

  &.completed {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #fff 100%);
    opacity: 1;

    span {
      color: var(--green) !important;
      background: none !important;
      -webkit-background-clip: none !important;
      -webkit-text-fill-color: var(--green) !important;
    }
  }

  &:not(:last-of-type) {
    .progressItemCircle,
    .spinner {
      &::after {
        content: '';
        position: absolute;
        width: 1px;
        height: var(--line-height, 18px);
        top: 20px;
        left: 8.5px;
        right: 0;
        background-image: linear-gradient(var(--dark-20) 33%, rgba(255, 255, 255, 0) 0%);
        background-position: right;
        background-size: 1px 6px;
        background-repeat: repeat-y;
      }
    }

    .spinner::after {
      left: 9px;
      top: 21px;
    }
  }

  @include for-phone-only {
    &:not(:last-of-type) {
      .progressItem {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          width: 1px;
          top: 26px;
          bottom: -16px;
          left: 9.5px;
          background-image: linear-gradient(var(--dark-20) 33%, rgba(255, 255, 255, 0) 0%);
          background-position: right;
          background-size: 1px 6px;
          background-repeat: repeat-y;
        }
      }

      .progressItemCircle::after {
        display: none;
      }
    }
  }

  h5 {
    color: rgba(0, 153, 247, 1) !important;
  }

  &.running {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #fff 100%);
    opacity: 1;

    h5 {
      background: linear-gradient(90deg, #0099f7 0%, rgba(0, 153, 247, 0.4) 56.25%, #0099f7 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-size: 500% auto;
      animation: textShine 2s ease-in-out infinite alternate;
    }
  }

  &.completed {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #fff 100%);
    opacity: 1;

    h5 {
      color: rgba(0, 153, 247, 1) !important;
      background: none !important;
      -webkit-background-clip: none !important;
      -webkit-text-fill-color: rgba(0, 153, 247, 1) !important;
    }
  }
}

.buttonsContainer {
  position: absolute;
  bottom: 40px;
  display: flex;
  gap: 15px;
}

.cancelButton {
  background: var(--light-100);
  border-radius: 10px;
}

.headerAndDescription {
  display: flex;
  flex-direction: column;
  gap: 24px;

  h2 {
    max-width: 320px;
    margin: 0 auto !important;
  }

  .description {
    font-size: 18px;
  }
}

@keyframes textShine {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}

.progressItem {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;

  &.showLoadingSpinner {
    align-items: center;
  }

  .textAndElementContainer {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .textContainer {
    display: flex;
    align-items: center;
    width: 100%;

    .ellipsesContainer {
      opacity: 0;
      visibility: hidden;

      &.running {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .progressItemCircle {
    border-radius: 99px;
    border: 1px solid var(--dark-15);
    background: var(--dark-3);
    display: flex;
    width: 20px;
    height: 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1/1;
    position: relative;
    margin-top: 2px;
    z-index: 1;

    &.completed {
      background: var(--green);
      border: 1px solid transparent;
    }
  }

  @include for-phone-only {
    flex: 1;
    padding-right: 10px;

    .textAndElementContainer {
      flex: 1;
      min-width: 0;
    }
  }
}

.spinner {
  position: relative;

  div {
    background: conic-gradient(
      from 90deg at 50% 50%,
      rgba(143, 152, 169, 0) 0deg,
      rgba(65, 150, 253, 1) 359.96deg,
      rgba(143, 152, 169, 0) 360deg
    );
    height: 20px;
    width: 20px;

    &:after {
      height: 14px;
      width: 14px;
    }
  }
}
